import { render, staticRenderFns } from "./assemblyDetail.vue?vue&type=template&id=769f4c6e&scoped=true&"
import script from "./assemblyDetail.vue?vue&type=script&lang=js&"
export * from "./assemblyDetail.vue?vue&type=script&lang=js&"
import style0 from "./assemblyDetail.vue?vue&type=style&index=0&id=769f4c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f4c6e",
  null
  
)

export default component.exports